import { render, staticRenderFns } from "./WorkDetail16.vue?vue&type=template&id=0bea72a9&scoped=true&"
import script from "./WorkDetail16.vue?vue&type=script&lang=js&"
export * from "./WorkDetail16.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail16.vue?vue&type=style&index=0&id=0bea72a9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea72a9",
  null
  
)

export default component.exports